<template>
  <main class="l-common__review__main" role="main" id="common-reviews">
    <BaseReviewsMenu
      v-if="isRenderMenu"
      :count="count"
      :default-sort-value="defaultSortValue"
      :default-refine-value="defaultRefineValue"
      :is-render-refiner="isRenderRefiner" />
    <ul class="review__list">
      <li v-for="review in reviews" :key="review.review_id">
        <CommonReview
          :review="review"
          :is-render-review-item="isRenderReviewItem"
          :is-render-user-info="isRenderUserInfo"
          @on-deleted="onDeleted"/>
      </li>
    </ul>
    <div class="m-common__review__more" v-if="isRenderReviewMore">
      <button v-if="isRenderReviewMoreButton" @click="onClickMoreReviews">もっと見る</button>
    </div>
  </main>
</template>

<script>
import BaseReviewsMenu from '@/components/BaseReviewsMenu'
import CommonReview from '@/components/CommonReview'
import errors from '@/mixins/errors'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'CommonReviews',
  mixins: [ errors ],
  components: { BaseReviewsMenu, CommonReview },
  props: {
    isRenderMenu: {
      type: Boolean,
      required: true
    },
    defaultSortValue: {
      type: String,
      required: true
    },
    defaultRefineValue: {
      type: String,
      required: true
    },
    isRenderReviewItem: {
      type: Boolean,
      default: true
    },
    isRenderRefiner: {
      type: Boolean,
      default: false
    },
    isRenderUserInfo: {
      type: Boolean,
      default: false
    },
    isRenderReviewMore: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters({
      count: 'storeReviews/count',
      reviews: 'storeReviews/reviews'
    }),
    isRenderReviewMoreButton () {
      return this.count > this.reviews.length
    }
  },
  methods: {
    ...mapActions({
      moreReviews: 'storeReviews/moreReviews'
    }),
    onClickMoreReviews () {
      this.moreReviews().catch(error => {
        alert(error.message)
      }).then(() => {
        if (this.isAuthenticationError) {
          this.onAuthenticationError()
        }
      })
    },
    onDeleted (data) {
      this.$emit('on-deleted', data) // 親画面へ通知
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CommonReviews.vue